import React from 'react';
import _ from 'lodash';
import {
  ReferralProgramGroupSelect,
} from '../components';
import { pluckSelectedProgramIds } from '.';

/**
 * Renders a single field row for group/program selection.
 * This is a plain function (not a React component) so that Enzyme shallow
 * rendering can still find ReferralProgramGroupSelect in the parent tree.
 */
export default function renderFieldRow({
  allowEmptyGroups,
  debouncedSearchNetworkGroups,
  errorsByField,
  groupKey,
  hide,
  index,
  onProgramGroupSelect,
  originCoordinates,
  programKey,
  referral,
  selected,
  selectedFields,
  sensitiveErrorsByField,
  sensitiveErrorKey,
  serviceAreaSupportForOrgsFlag,
  suggestedGroups,
  width,
}) {
  const selectedGroupId = _.get(selected[groupKey], 'value.id');
  const field = selected[groupKey];
  const fieldErrors = errorsByField[field.value.id];
  const sensitiveFieldErrors = sensitiveErrorsByField[sensitiveErrorKey];
  const sensitiveErrors = _.get(field, 'value.id') === sensitiveErrorKey ? sensitiveFieldErrors : [];

  return (
    <div className="row" key={selectedGroupId ?? index}>
      <div className={`col-xs-${width || 12}`}>
        <ReferralProgramGroupSelect
          allowEmptyGroups={allowEmptyGroups}
          groupErrors={_.isEmpty(fieldErrors) ? sensitiveErrors : fieldErrors}
          debouncedSearchNetworkGroups={debouncedSearchNetworkGroups}
          hidden={hide}
          index={index}
          onProgramGroupSelect={onProgramGroupSelect}
          programField={selected[programKey]}
          selectedProgramIds={pluckSelectedProgramIds(selectedFields)}
          serviceAreaSupportForOrgsFlag={serviceAreaSupportForOrgsFlag}
          suggestedGroups={suggestedGroups}
          referral={referral}
          originCoordinates={originCoordinates}
          groupsOptionType="in-network"
        />
      </div>
    </div>
  );
}
